# Used in Calculations
# Sets a default value on the habitation costs, based on the given couple situation

SINGLE_HABITATION_COSTS = 2000
COUPLE_HABITATION_COSTS = 2500

setDefaultValue = ->
  $this = $ @
  futureValue = if this.value == 'single' then SINGLE_HABITATION_COSTS else COUPLE_HABITATION_COSTS
  currentValue = if this.value == 'single' then COUPLE_HABITATION_COSTS else SINGLE_HABITATION_COSTS
  $('[data-default-value]').each (index, view) ->
    $view = $ view
    if $view.val().length == 0 || ($CAM.parseCurrency($view.val()) == currentValue && $view.data('default'))
      $view.val(futureValue)
      $view.data('default', 'true')

$(document).on 'change', '[data-default-source]', setDefaultValue
$(document).on 'input', '[data-default-value]', ->
  $(@).data('default', 'false')

init = ->
  $('[data-default-source]').each (index, element) ->
    setDefaultValue.call(element)

$(document).on 'reload:done', init
$(document).ready(init)
